export const BYTES_PER_MEGABYTE = 1e6;
export const MAX_FILE_SIZE = 25e6; // 25MB
export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
];
